<div class="item">

    <a [target]="openInNewPage ? '_blank' : undefined" > 
        <div class="item-link" coreTooltip="Sayfaya Git" (click)="openInNewPage ? (undefined) : closeDialog()" role="button"  tabindex="-1">
            O
        </div>
    </a>

    <div><b>{{data.id}}</b></div>
    <div *ngIf="data.name">{{data.name}}</div>
    <div *ngIf="data.protocolNo">{{data.protocolNo}}</div>
    <div *ngIf="data.date">{{data.date | date: 'dd.MM.yyyy'}}</div>

    <div class="pin" *ngIf="!pinned">
        <p-button icon="pi pi-star" coreTooltip="Favorilere Ekle" [text]="true" size="small" (onClick)="pinItem()"></p-button>
    </div>
    <div class="pinned" *ngIf="pinned">
        <p-button icon="pi pi-star-fill" coreTooltip="Favorilerden Kaldır" [text]="true" size="small" (onClick)="unpinItem()"></p-button>
    </div>

</div>